module.exports = __webpack_public_path__ + "static/ARTS_IMAGE_3-712ff8181946e8620de87d0bd626cb1a.jpg";